import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UIRouter, Transition } from "@uirouter/angular";
import { ApiService } from "../api-service/api.service"
import { RewardsService } from "../rewards-service/rewards.service"
import { ClientConfigService } from "../client-config-service/client-config.service"
import swal from 'sweetalert2';
import { FormGroup, FormArray, FormControl, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-rewards-edit-overlay',
  templateUrl: './rewards-edit-overlay.component.html',
  styleUrls: ['./rewards-edit-overlay.component.less']
})
export class RewardsEditOverlayComponent implements OnInit {
 
  rewardForm: FormGroup;
  private allProducts: any;
  private userIsEditingReward = false;
  productsData = []
  
  @Output()
  rewardsEvent: EventEmitter<any> = new EventEmitter();
  constructor(private rewardsService: RewardsService, private clientConfigService: ClientConfigService, private router: UIRouter, private fb: FormBuilder, private apiService: ApiService) {
    this.rewardForm = this.fb.group(
      {
        reward_code: new FormControl('', [Validators.required, Validators.pattern('^[A-Za-z0-9-]{2,40}$')]),
        reward_desc: new FormControl(''),
        reward_affiliate: new FormControl(''),
        reward_url: new FormControl(''),
        reward_value: new FormControl('', Validators.required),
        products: new FormArray([]),
        type:  new FormControl('')

      }
    )

  }

  subscribeToRewards() {
    if(this.router.globals.params.rewardID){

      this.rewardsService.rewardId = this.router.globals.params.rewardID
      this.rewardsService.rewardData.subscribe((x) => {
        
        this.rewardForm.patchValue(x)
      })
    }

  }

  subscribeToClient() {

    this.clientConfigService.clientConfig.subscribe((x) => {
      this.allProducts = x.products
      this.createCheckboxes(this.allProducts)

    })
  }

  ngOnInit() {
    this.subscribeToClient()
    this.subscribeToRewards()

    if(this.router.globals.params.rewardID){
      this.userIsEditingReward = true
    }

  }
 
  createCheckboxes(data) {
    
    this.productsData = data
    
     data.forEach((object, index) => {

      const control = new FormControl(); // if first item set to true, else false
      (this.rewardForm.controls.products as FormArray).push(control);
    });

  }

  updateRewardCode() {

    const products = this.rewardForm.value.products.map((value, index) => (value ? this.productsData[index].id : null)).filter(value => value !== null);
    delete this.rewardForm.value.products
    let postData = Object.assign({ products }, this.rewardForm.value);
    if(postData.type == 3 || postData.type == 5){
      postData.discount_amount = postData.reward_value;
    }

    if(postData.type == 1){
      postData.cashback_amount = postData.reward_value;
    }
    if(this.router.globals.params.rewardID){
     
      this.apiService.request('PUT', '/reward/' + this.router.globals.params.rewardID, {}, postData)
      .then((response) => {
        
        this.rewardsService.retrieveRewards()
        
        swal({
          title: "Code Updated",
          type: "success",
          
        })
        .then((selection) => {
          this.router.stateService.go('app.rewards')
          
        })
        .catch(swal.noop);
        
      })
      .catch((error) => {
        
      })
    } else {
        
    this.apiService.request('POST', '/reward', {}, postData)
    .then((response) => {
      
      this.rewardsService.retrieveRewards()

      swal({
        title: "Code Added Successfully",
        type: "success",

      })
        .then((selection) => {

        this.router.stateService.go('app.rewards')
        })
        .catch(swal.noop);

    })
    .catch((error ) => {
      
      swal({
        title: error,
        type: "error",

      })
  
    })
 
    }

  }
 
  closeSidebar() {
    this.router.stateService.go('app.rewards')
  }
  
}



// WEBPACK FOOTER //
// /Users/matthewspringbett/sites/worryandpeace/valhalla/src/app/rewards-edit-overlay/rewards-edit-overlay.component.ts